module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Kids Party Room_RGB_lr.44c0159a.jpg";